import React from "react";

import ContactUsPageV1 from "../../component/pages/ContactUsPage";
import ContactUsPageV2 from "../../V2/components/pages/ContactUsPage";

function ContactUs() {
  const isV2 = process.env.NEXT_PUBLIC_REACT_APP_SKIN === "taxnumber"
    || process.env.NEXT_PUBLIC_REACT_APP_SKIN === "federaltaxid"
    || process.env.NEXT_PUBLIC_REACT_APP_SKIN === "fileforein"
    || process.env.NEXT_PUBLIC_REACT_APP_SKIN === "reflection-1"
    || process.env.NEXT_PUBLIC_REACT_APP_SKIN === "reflection-2"
    || process.env.NEXT_PUBLIC_REACT_APP_SKIN === "reflection-3"
    || process.env.NEXT_PUBLIC_REACT_APP_SKIN === "reflection-4";

  if (isV2) {
    return (
      <ContactUsPageV2 />
    )
  }

  return (
    <ContactUsPageV1 />
  );
}

export default ContactUs;
